import { useCallback } from "react";
import { useSelector } from "react-redux";

import {
  guardGuestAction,
  isGuestActionRestricted,
  isGuestRoleRequiredError,
  requestGuestConversionModal,
} from "../constants/guestRestrictions";
import { useEventIntakeEnabled } from "./useEventIntakeEnabled";
import { RootState } from "../store/store";

export function useGuestActionGuard() {
  const eventIntakeEnabled = useEventIntakeEnabled();
  const user = useSelector((state: RootState) => state.user.user);

  const isRestricted = isGuestActionRestricted(user, eventIntakeEnabled);

  const guardAction = useCallback(
    (action: () => void) => guardGuestAction(user, eventIntakeEnabled, action),
    [user, eventIntakeEnabled]
  );

  const handleGuestApiError = useCallback((error: unknown) => {
    if (isGuestRoleRequiredError(error)) {
      requestGuestConversionModal();
      return true;
    }
    return false;
  }, []);

  return {
    isRestricted,
    guardAction,
    handleGuestApiError,
  };
}
